<template>
  <div>
    <el-table
      :data="
        data.filter(
          data =>
            !user_id ||
            data.user_id.toLowerCase().includes(user_id.toLowerCase())
        )
      "
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
    >
      <!-- <el-table-column label="User" sortable>
        <template slot-scope="props">
          {{ props.row.user.first_name }} {{ props.row.user.surname }}
        </template>
      </el-table-column> -->
      <el-table-column prop="user_id" sortable>
        <template slot="header">
          <el-input class="w50" v-model="user_id" placeholder="Search" />
          <br />
          <span>User ID</span>
        </template>
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column
        label="Subscription plan ID"
        prop="subscription_plan_id"
        sortable
        :filters="[
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 }
        ]"
        :filter-method="filterIs"
      ></el-table-column>
      <el-table-column
        label="BT Plan ID"
        prop="bt_plan_id"
        sortable
      ></el-table-column>
      <el-table-column
        label="Downloaded items"
        prop="downloaded_items"
        sortable
        :filters="[{ text: 'Not empty', value: '' }]"
        :filter-method="filterNot"
      ></el-table-column>
      <el-table-column label="Report on date" prop="on_date" sortable>
        <template slot-scope="props">
          {{ props.row.on_date | date }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="data.current_page"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="data.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      user_id: null
    }
  },

  computed: {
    ...mapState('reportUser', [
      'data',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('reportUser', ['read']),
    ...mapMutations('reportUser', ['setPage', 'setPageSize', 'setOrdering']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    filterNot(value, row) {
      return row.downloaded_items !== value
    },
    filterIs(value, row) {
      return row.subscription_plan_id === value
    }
  },

  created() {
    this.read()
  }
}
</script>
